import { render, staticRenderFns } from "./AppTableStatusInfoIcon.vue?vue&type=template&id=63b40ac0&"
import script from "./AppTableStatusInfoIcon.vue?vue&type=script&lang=js&"
export * from "./AppTableStatusInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports